/* eslint-disable react-hooks/rules-of-hooks -- needed */
/* eslint-disable camelcase -- needed */

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { getSelectedProduct, getProductRegistryById, getProducts } from '@americanexpress/product-ducks';
import { Selectors, generateUrls } from '@americanexpress/axp-benefits-utils';
import { fromJS } from 'immutable';
import { redirectToCenturionLogin, redirectToMycaLogin } from '../new/view-all/utils';
import ViewAll from '../new/view-all/components/NewViewAllPage';
import useOneData from '../hooks/useOneData';
import { getEndpoint, getReadBenefitsRequestBody } from '../api/api-utils';
import { ReadLoyaltyBenefitsVx } from '../constants';
import Error from '../new/shared/components/error';

export function WrapViewAll(properties) {
  const location = properties?.location;
  const login = properties?.login;
  const cardNameState = properties?.cardDetails;
  const cardNameParams = properties?.params?.cardname;
  const getCardNameFromState = cardNameState?.cardName;
  const cardNameValueToUse = getCardNameFromState || cardNameParams;
  const path = properties?.location?.pathname.toLowerCase();
  const faasApiUrl = properties?.faasApiUrl;
  const accountToken = properties?.accountToken;
  const endpoint = getEndpoint(faasApiUrl, ReadLoyaltyBenefitsVx);
  const productType = properties?.productType;
  const centurionLoginUrl = properties?.CENTURION_LOGIN_URL;
  const mycaLoginUrl = properties?.MYCA_LOGIN_URL;
  const locale = properties?.locale;
  const account_status = properties?.account_status;

  // Parse category from query string
  let categoryFromQuery = null;
  if (location && location.search) {
    const params = new URLSearchParams(location.search);
    categoryFromQuery = params.get('category');
  }

  if ((account_status === 'Canceled') && login) {
    return (
      <Error />
    );
  }

  const requestBody = getReadBenefitsRequestBody(accountToken, cardNameValueToUse, login, productType, locale);
  const endpointOptions = {
    body: requestBody,
  };

  const shouldFetch = account_status === 'Canceled';

  const {
    isLoading: loadingReadLoyaltyBenefits,
    data: readLoyaltyBenefits,
    error: readLoyaltyBenefitsError,
  } = useOneData(shouldFetch ? null : endpoint, shouldFetch ? null : endpointOptions);

  const loggedInOnly = readLoyaltyBenefits?.cardProduct?.loggedInOnly || properties.loggedInOnly || 'false';

  const handleLoggedInOnlyRedirect = () => {
    if (loggedInOnly && loggedInOnly === 'true') {
      if (!login) {
        /*
              if user is going to a centurion detail page while not logged in.
              They are redirected to the centurion login hub
              If not then they are sent to standard MYCA Login
         */
        if (cardNameValueToUse?.includes('centurion')) {
          redirectToCenturionLogin(centurionLoginUrl);
        } else {
          redirectToMycaLogin(mycaLoginUrl, path);
        }
        /*
           This prevents a user from navigating to a card they should not be abe to
           see while logged in on their view all page
         */
      } else if (path.includes('view-all') && path.includes(cardNameValueToUse?.toLowerCase())) {
        push('/card-benefits/view-all');
      }
    } else if (locale !== 'en-US' && !login) {
      redirectToMycaLogin(mycaLoginUrl, path);
    }
  };

  useEffect(() => {
    handleLoggedInOnlyRedirect();
  }, [loggedInOnly, login]);

  if (readLoyaltyBenefits?.errorCode === 'dsc-ben-0400' && login) {
    return (
      <Error />
    );
  }

  return (
    <ViewAll
      loadingReadLoyaltyBenefits={loadingReadLoyaltyBenefits}
      readLoyaltyBenefits={readLoyaltyBenefits}
      readLoyaltyBenefitsError={readLoyaltyBenefitsError}
      accountToken={properties?.accountToken}
      cardname={cardNameValueToUse}
      fromParams={!!cardNameParams}
      location={location}
      initialCategory={categoryFromQuery}
    />
  );
}

export function mapStateToProps(state) {
  const env = fromJS(state).getIn(['config', 'localeFilename']);
  const product = getSelectedProduct(state);
  const accountToken = getSelectedProduct(state);
  const accStatus = getProducts(state)[accountToken];

  return {
    MYCA_LOGIN_URL: generateUrls(env).MYCA_LOGIN_URL,
    CENTURION_LOGIN_URL: generateUrls(env).CENTURION_LOGIN_URL,
    CORPORATE_URL: generateUrls(env).CORPORATE_URL,
    cardNameState: Selectors.getCardNameFromState(state),
    login: Boolean(getSelectedProduct(state)),
    faasApiUrl: fromJS(state).getIn(['config', 'faasApiUrl']),
    accountToken: getSelectedProduct(state),
    productType: getProductRegistryById(state, product)?.type,
    locale: fromJS(state).getIn(['intl', 'activeLocale']),
    account_status: accStatus?.status?.account_status?.[0],
  };
}

export const ComponentUnderTest = WrapViewAll;
export default connect(mapStateToProps, null)(WrapViewAll);

/* eslint-enable react-hooks/rules-of-hooks -- needed */
/* eslint-enable camelcase -- needed */
